// gsap register plugin
gsap.registerPlugin(ScrollTrigger);
const showAnim = gsap
  .from(".vpm-header", {
    yPercent: -150,
    paused: true,
    duration: 0.2,
  })
  .progress(1);

const isHomepage = document.querySelector(".page-index");
if (!isHomepage) {
  ScrollTrigger.create({
    start: "top top",
    end: "max",
    onUpdate: (self) => {
      self.direction === -1 ? showAnim.play() : showAnim.reverse();
    },
  });
}
